// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import BookmarkNotes from '@app/features/messaging/state/BookmarkNotes';
import SavedMessages from '@app/features/messaging/state/SavedMessages';

interface SavedMessageDeletePayload {
	message_id: string;
}

export function handleSavedMessageDelete(data: SavedMessageDeletePayload, _context: GatewayHandlerContext): void {
	SavedMessages.handleMessageDelete(data.message_id);
	// LOCAL-ONLY (favorites-bookmarks-plan.md section 1.5): the note goes with the bookmark. Exclude from upstream sync.
	BookmarkNotes.remove(data.message_id);
}
